import dayjs from 'dayjs';

const DATE_FORMATS = {
  time: 'HH:mm',
  dateTime: 'DD.MM.YYYY HH:mm',
  date: 'DD.MM.YY',
} as const;

export type DateFormat = keyof typeof DATE_FORMATS;

export const formatDateTime = (
  value: string,
  format: DateFormat = 'dateTime',
): string => {
  return dayjs(value).format(DATE_FORMATS[format]);
};
